import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import dataAids from '../../../constants/dataAids';

import CategoriesMobile from './CategoriesMobile';
import AllProducts from './AllProducts';
import { mapContextToProps } from '../OlsShopContext';

const styles = {
  container: {
    borderWidth: '1px',
    borderColor: 'section',
    borderStyle: 'solid',
    height: '51px',
    color: 'section',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  drawerContent: {
    marginVertical: 'large',
    marginHorizontal: 'medium'
  }
};

function DrawerMobile(props) {
  const {
    Element: { Details },
    Component: { Drawer },
    Group: { Nav }
  } = UX2;
  const {
    taxons,
    selectedTaxonPermalink,
    routePath,
    isSearch,
    onClick,
    translate = () => {}
  } = props;

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => setDrawerOpen(prev => !prev);

  const onCategoryClick = (...params) => {
    onClick(...params);
    toggleDrawer();
  };

  const allProductsInfo = OlsConfigStore.getAllProductsInfo() || {};
  const allProductsPosition = allProductsInfo?.position || 0;
  const allProducts = (
    <Details>
      <AllProducts
        allProductsInfo={ allProductsInfo }
        selectedTaxonPermalink={ selectedTaxonPermalink }
        isSearch={ isSearch }
        routePath={ routePath }
        onClick={ onCategoryClick }
        bottomSpace
        separator
        overflowHidden
      />
    </Details>
  );

  const taxonList = CategoriesMobile({
    taxons,
    routePath,
    selectedTaxonPermalink,
    onClick: onCategoryClick,
    separator: true
  });
  taxonList.splice(allProductsPosition, 0, allProducts);

  return (
    <React.Fragment>
      <Details
        data-aid={ dataAids.TOGGLE_MOBILE_LIST }
        onClick={ toggleDrawer }
        style={ styles.container }
      >
        { translate('categories.categories') }
      </Details>
      <Drawer
        category='neutral'
        isOpen={ isDrawerOpen }
        left={ false }
        maxWidth='80%'
        backgroundColor='white'
        onCloseClick={ toggleDrawer }
      >
        <Nav.Vertical style={ styles.drawerContent }>{ taxonList }</Nav.Vertical>
      </Drawer>
    </React.Fragment>
  );
}

DrawerMobile.propTypes = {
  taxons: PropTypes.array,
  selectedTaxonPermalink: PropTypes.string,
  onClick: PropTypes.func,
  routePath: PropTypes.string,
  isSearch: PropTypes.bool,
  translate: PropTypes.func
};

export default mapContextToProps(DrawerMobile, context => ({
  translate: context.translate
}));
